import { GenericAPI } from '@belong/api/services/GenericAPI';
import { AUTH_API_ROUTES, IGenericFetchResult, INetworkResponse } from '@belong/types';
import {
  IGetResetLinkRequest,
  IGetResetLinkResponse,
  IVerifyAccountRequest,
  IVerifyAccountResponse
} from '@belong/types/api/auth';

class AuthAPI extends GenericAPI {
  async getResetLink(payload: IGetResetLinkRequest): INetworkResponse<IGetResetLinkResponse> {
    return this.post(AUTH_API_ROUTES.RESET_PASSWORD, payload, { includeCredentials: false, includeIdToken: false });
  }

  async verifyAccount(payload: IVerifyAccountRequest): Promise<IGenericFetchResult<IVerifyAccountResponse>> {
    return this.post(AUTH_API_ROUTES.VERIFY_ACCOUNT, payload);
  }

  async verifyEmail(): Promise<IGenericFetchResult<Record<string, never>>> {
    return this.post(AUTH_API_ROUTES.VERIFY_EMAIL, {});
  }

  async verifyEmailPasswordless(email: string): Promise<IGenericFetchResult<any>> {
    return this.post(
      AUTH_API_ROUTES.VERIFY_EMAIL_PASSWORDLESS,
      { email },
      { includeCredentials: false, includeIdToken: false }
    );
  }
}

export const authAPI = new AuthAPI();
